import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { Address } from "../../types";

const initialState: Address = {
  address_id: 0,
  name: "",
  email: "",
  user_id: undefined,
  address_1: "",
  address_2: "",
  landmark: "",
  state: "",
  state_id: "",
  city: "",
  pincode: "",
  is_default: false,
  profile_update: false,
};

const addressSlice = createSlice({
  name: "address_store",
  initialState,
  reducers: {
    setAddress: (state, action: PayloadAction<Partial<Address>>) => {
      return { ...state, ...action.payload };
    },
 setPincode: (state, action: PayloadAction<string>) => {
  state.pincode = action.payload;
},
    resetAddress: () => initialState,
  },
});

export const selectAddress = (root: RootState) => root.address;

export const { setAddress, resetAddress ,setPincode} = addressSlice.actions;
export default addressSlice.reducer;